<template>

  <svg
    t="1629556429050"
    class="icon"
    viewBox="0 0 1024 1024"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    p-id="4369"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    width="64"
    height="64"
  ><path d="M172.08888854 967.11111147a45.51111147 45.51111147 0 0 1-45.5111104-45.51111147V102.4a45.51111147 45.51111147 0 0 1 45.5111104-45.51111147h637.15555626a45.51111147 45.51111147 0 0 1 45.5111104 45.51111147v136.53333333h-91.02222186V147.91111147H217.6v728.17777706h546.13333334v-91.02222186h91.02222186v136.53333333a45.51111147 45.51111147 0 0 1-45.5111104 45.51111147H172.08888854z m591.6444448-273.06666667v-136.53333333h-318.57777814v-91.02222294h318.57777814V329.9555552l227.5555552 182.0444448-227.5555552 182.0444448z" p-id="4370" /></svg>


</template>

<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'JtIconLogout',
} as DefineComponent
</script>